import React from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
import { useSearch } from '../contexts/SearchContext';

const GlobalSearch: React.FC = () => {
  const { searchTerm, setSearchTerm } = useSearch();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Search is handled in real-time via onChange
  };

  return (
    <div className="px-4 py-3 bg-white border-b border-gray-100 shadow-sm">
      <form onSubmit={handleSearch} className="relative">
        <div className="relative">
          <SearchIcon 
            size={20} 
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" 
          />
          <input 
            type="text" 
            value={searchTerm} 
            onChange={e => setSearchTerm(e.target.value)} 
            placeholder="Search by name or phone..." 
            className="w-full bg-gray-50 text-gray-900 placeholder-gray-500 border border-gray-200 rounded-xl py-3 pl-12 pr-12 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 focus:bg-white transition-all duration-200 shadow-sm hover:shadow-md" 
          />
          {searchTerm && (
            <button 
              type="button" 
              onClick={() => setSearchTerm('')} 
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
            >
              <XIcon size={18} />
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default GlobalSearch;